var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tree',{attrs:{"data":_vm.data,"props":_vm.defaultProps},on:{"node-click":_vm.handleNodeClick}})}
var staticRenderFns = []

export { render, staticRenderFns }